import { SwitchOption, Switcher } from "components/Switcher/Switcher";
import { MatchSet, getMatchSetDisplayScores } from "model/Match/Set/MatchSet";
import { SetSwitcherScore } from "./styles";
import { MatchTeams } from "model/Match/MatchTeams";
import {
  selectRosterDisplayName,
  selectRosterDisplayTrigram,
} from "selectors/Roster";
import { getDefinedRosterIds } from "model/Roster/Roster";
import { useAppSelector } from "app/hooks";

interface Props {
  sets: MatchSet[];
  teams: MatchTeams;
  tournamentId: string;
  setAdvantageRosterIds: string[];
  selectedSetIdx: number | undefined;
  setSelectedSetIdx: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const MatchSetSwitcher = ({
  sets,
  teams,
  tournamentId,
  setAdvantageRosterIds,
  selectedSetIdx,
  setSelectedSetIdx,
}: Props) => {
  const options: SwitchOption<number>[] = [];

  const setAdvantageNames = useAppSelector((state) =>
    setAdvantageRosterIds.map(
      (id) => selectRosterDisplayName(state, id, tournamentId) ?? "-"
    )
  );

  const setAdvantageTrigrams = useAppSelector((state) =>
    setAdvantageRosterIds.map(
      (id) => selectRosterDisplayTrigram(state, id, tournamentId) ?? "-"
    )
  );

  const hasSetAdvantage = setAdvantageRosterIds.length > 0;
  if (hasSetAdvantage) {
    options.push({
      display: `Set Adv (${setAdvantageTrigrams.join(" | ")})`,
      selectable: false,
      title: `${setAdvantageNames.join(
        " | "
      )} enter the match with a one set advantage`,
    });
  }

  sets.forEach((s, i) => {
    const displayScores = getMatchSetDisplayScores(s);
    options.push({
      display: (
        <>
          {s.isTiebreaker
            ? "Tiebreak"
            : `Set ${i + 1 + (hasSetAdvantage ? 1 : 0)} `}
          {!!displayScores && (
            <SetSwitcherScore>
              {getDefinedRosterIds(teams.rosters)
                .map((id) => displayScores[id] ?? "-")
                .join(" - ")}
            </SetSwitcherScore>
          )}
        </>
      ),
      selectable: true,
      value: i,
    });
  });

  return (
    <Switcher
      options={options}
      selectedValue={selectedSetIdx}
      setSelectedValue={setSelectedSetIdx}
    />
  );
};
